import { useDialog as useDaxDialog } from '@global-dax-ad-platform/dax-components';
import { RefreshIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Button } from '@global-engineering-shared/gweb-material-ui';
import MenuItem from '@material-ui/core/MenuItem';

import useStyles from 'features/DataManagement/components/ActionButton/ActionButton.styles';

type TUploadActionButtonProps = {
  dataType: string;
  uploadInProgress: boolean;
  handleClose: () => void;
  dialogId: string;
};

const UploadActionButton: React.FC<TUploadActionButtonProps> = ({
  uploadInProgress,
  handleClose,
  dialogId,
}) => {
  const classes = useStyles();
  const { openDialog } = useDaxDialog();

  const handleReplaceClick = () => {
    openDialog(dialogId);
    handleClose();
  };

  return (
    <MenuItem key="Replace CSV" disableGutters className={classes.menuItem}>
      <Button
        startIcon={<RefreshIcon data-testid="refresh-icon" />}
        disabled={uploadInProgress}
        className={classes.actionButton}
        onClick={handleReplaceClick}
      >
        Replace CSV
      </Button>
    </MenuItem>
  );
};

export default UploadActionButton;
